// Internal modules
import { appStore } from '@/store';
import {
  $logger,
  FIELD_LEVEL_ERRORS,
  focusOnFirstError,
  getContent,
  handleApiError,
  PAGE_LEVEL_ERRORS,
  parseGqlError,
} from '@/lib';

const onboardErrorHandler = err => {
  const {
    error,
    errorData,
    isFiConfirmationContingency,
    isOasError,
    message,
  } = parseGqlError(err);
  const { form: formState } = appStore.getState();
  const { value: onboardOption } = formState.onboardOption;
  const actions = appStore.getActions();

  actions.ui.toggleIsFormSubmitting(false);

  $logger.info(`weasley_onboard_${onboardOption}_error`, {
    error: message,
  });

  if (isOasError && errorData?.length) {
    const filteredErrors = errorData.filter(f => f);
    const { code: firstFieldError } = filteredErrors[0] || {};
    // Some OAS errors aren't mapped and return `null` as the error
    // object. For those errors we'll fallback since we aren't able
    // to instruct the user on the steps necessary to fix the issue.
    if (FIELD_LEVEL_ERRORS.hasOwnProperty(firstFieldError)) {
      // Only the billing address is passed to OAS, so if there is an address
      // error it is for the billing address, not the shipping address
      const billingFields = /city|line1|line2|postalCode|state/;
      filteredErrors.forEach(({ code }) => {
        const { contentKey, field } = FIELD_LEVEL_ERRORS[code];

        if (!formState[field] && !formState.billingAddress[field]) {
          return;
        }

        const isBillingField = billingFields.test(field);
        const action = isBillingField
          ? 'updateAddressField'
          : 'updateNonAddressField';
        const payload = {
          displayError: true,
          error: getContent(contentKey),
          isValid: false,
        };

        actions.form[action]({
          ...(isBillingField && { addressType: 'billingAddress' }),
          field,
          payload,
        });
      });

      return focusOnFirstError(appStore.getState().form);
      // For some OAS errors we show a page level error
    } else if (PAGE_LEVEL_ERRORS.hasOwnProperty(firstFieldError)) {
      error.message = firstFieldError;
    } else {
      // Adding this log for the time being so we can keep track of
      // any OAS errors that we need to map
      $logger.warn('weasley_unmapped_oas_error', {
        code: firstFieldError,
        error: message,
      });
    }
  }

  if (
    isFiConfirmationContingency &&
    errorData?.confirmationMethod === 'ONE_TIME_PASSWORD_CONFIRMATION'
  ) {
    actions.api.setCupOtpFundingInstrumentId(errorData.fundingInstrumentId);
    // encryptedCardLoginAccountNumber only exists for guest transactions
    // which have a card linked login account number.
    errorData.encryptedCardLoginAccountNumber &&
      actions.api.setCupOtpEncryptedCardLoginAccountNumber(
        errorData.encryptedCardLoginAccountNumber,
      );
    return actions.ui.setIsOneTimePasswordConfirmationOpen(true);
  }

  actions.ui.toggleIsThreeDS1Shown(false);

  handleApiError(error);
};

export { onboardErrorHandler };
